import { useState } from 'react'
import { Button, Modal } from 'react-bootstrap'

import { ToastType, useToast } from '../../../hooks/useToast'
import { useDeleteClientMutation } from '../../../modules/store/dochubApi/dochubApi'
import { Client } from '../../../modules/store/dochubApi/dochubTypes'
import Loader from '../../_atoms/Loader/Loader'
import OverlayWithText from '../../_atoms/OverlayWithText/OverlayWithText'

import styles from './styles.module.scss'

interface IProps {
    client: Client
    isOpen: boolean
    closeModal: () => void
    onSuccess?: () => void
}

const ModalDeleteClient = ({ client, isOpen, closeModal, onSuccess }: IProps) => {
    const [deleteClient, { isError }] = useDeleteClientMutation()
    const [isLoading, setIsLoading] = useState(false)

    useToast({ isTriggered: isError, type: ToastType.ERROR, message: 'Ошибка удаления клиента' })

    const confirm = async () => {
        setIsLoading(true)
        try {
            await deleteClient({ id: client.id }).unwrap()
            onSuccess?.()
            closeModal()
        } catch {
            // error handled by useToast
        }
        setIsLoading(false)
    }

    return (
        <Modal show={isOpen} onHide={closeModal} centered dialogClassName={styles.modal}>
            {isLoading && (
                <OverlayWithText backgroundBootstrapColor={'bg-secondary'}>
                    <Loader diameterInPx={100} thicknessInPx={10} />
                </OverlayWithText>
            )}
            <Modal.Header closeButton>
                <Modal.Title>
                    <b>Удалить?</b>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p>Удалить клиента {client.name}?</p>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={confirm}>
                    Удалить
                </Button>
                <Button variant="primary" onClick={closeModal}>
                    Отмена
                </Button>
            </Modal.Footer>
        </Modal>
    )
}

export default ModalDeleteClient
